import { Box, HStack, Header, Link } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const DrinksTabLink = Link.withConfig<{ active?: boolean }>(p => ({
  flexGrow: 1,
  isUnderlined: false,
  margin: 0,
  fontFamily: 'body',
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: 2,
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',

  _focus: {
    borderBottomColor: {
      base: p.active ? getDesignToken('color-tertiary') : 'transparent',
      md: p.active ? primitive.$bbqBrown : 'transparent',
    },
  },

  borderBottomColor: p.active ? getDesignToken('color-tertiary') : 'transparent',
  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

export const DrinksTabLinkText = Header.withConfig<{ active?: boolean }>(p => ({
  color: p.active ? getDesignToken('color-tertiary') : getDesignToken('color-tertiary'),
  fontFamily: p.active ? 'heading' : 'body',
  marginTop: 0,
  fontSize: { md: 'sm' },
  lineHeight: { md: 'md' },
}));

export const DrinksTabsWrapper = HStack.withConfig({
  position: 'relative',
  width: 'full',
  height: getDesignToken('layout-nav-height-mobile'),
  marginY: '2px',
  paddingTop: 2,
  background: 'transparent',
});

export const TabsContent = Box.withConfig({
  marginTop: {
    base: '$6',
    md: '$8',
  },
});
